import { Box, CircularProgress } from '@mui/material'
import BrandLogo from './BrandLogo'
import { colors } from '../theme'

export default function LoadingSpinner() {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        position: 'relative',
      }}
    >
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress size={80} thickness={2} sx={{ color: colors.brandNavy }} />
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {/* Glyph, not the lockup — the wide wordmark will not fit inside the ring */}
          <BrandLogo variant="glyph" height={36} alt="" sx={{ borderRadius: 1 }} />
        </Box>
      </Box>
    </Box>
  )
}
